/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable global-require */

import {
  ContractEnum,
  ContractEnumToContractType,
  ContractFileType,
} from '@/enums/contract-type';
import { contractPage } from '@/components/contract';
import { VueClass } from 'vue-class-component/lib/declarations';
import { Vue } from 'vue-property-decorator';
import URLUtils from '@/shared/utils/URLUtils';
import platform from './shared/utils/platform';

import {
  ALIPAYMINI_COMMODITY,
  HANGYINOLD_COMMODITY,
  HANGYIN_COMMODITY,
  HUXIAO_COMMODITY,
  MINSHENG_COMMODITY,
  NEW_YINHE_COMMODITY,
  QUDIAN_COMMODITY,
  WEIBO_COMMODITY,
  XIAOMI_COMMODITY,
  YINHE_COMMODITY,
  YXH_COMMODITY,
  CHONGTIANMEIDAI_COMMODITY,
  ZHONGYOU_COMMODITY,
  NEWORAGE_COMMODITY,
  ZHIDUXIAODAI_COMMODITY,
  DUXIAOMAN_COMMODITY,
  XIAOXIANG_COMMODITY,
  ZHONGYIN_COMMODITY,
  XIAOYINGKAYI_COMMODITY,
} from './shared/commodity';

import { openThirdPage } from './api/native/utils';
import { contractsUrl, isH5App } from './constant';

/** async components */

// 新银河-杭银 授信协议
const YHPreApplyChoose = () => import(
  /* webpackChunkName: "preapply-newYh-contract" */'@/views_v2/pre-apply-choose/contracts/newYH-contract'
) as any;
// 银河-杭银 授信协议-已走线上化，后续可以废弃
const YHApplyChoose = () => import(
  /* webpackChunkName: "newYh-preApply" */'@/views_v2/pre-apply-choose/contracts/newYh-preApply'
) as any;
const HSPreApplyContract = () => import(
  /* webpackChunkName: "hengsheng-preApply-contract" */'@/views_v2/pre-apply-choose/contracts/hengsheng-preApply-contract'
) as any;
const YXHContract = () => import(
  /* webpackChunkName: "check-contract" */'@/views_v2/pre-apply-choose/contracts/check-contract'
) as any;
const YXHContractCheck = () => import(
  /* webpackChunkName: "yxh-contract" */'@/views_v2/pre-apply-choose/contracts/\byxh-contract'
) as any;
const YXHSignContract = () => import(
  /* webpackChunkName: "yxh-credit" */'@/views_v2/pre-apply-choose/contracts/yxh-credit'
) as any;
const YXHContractCheckSign = () => import(
  /* webpackChunkName: "yxh-signContract" */'@/views_v2/pre-apply-choose/contracts/yxh-signContract'
) as any;
const YhPreApplyContracts = () => import(
  /* webpackChunkName: "contract-yh" */'@/views_v2/apply-product/components/contract-yh'
) as any;
// 上诉授信协议 都不再使用，后续可以废弃


// 芒果小贷对应提现协议
const MGApplyNotice = () => import( // 告知书
  /* webpackChunkName: "mangguo-apply-contract" */'@/views_v2/apply-product/components/mangguo-apply-contract/notice'
) as any;
const MGApplyContract = () => import( // 代款合同
  /* webpackChunkName: "mangguo-apply-contract" */'@/views_v2/apply-product/components/mangguo-apply-contract/contract'
) as any;
const MGApplyGuarantee = () => import( // 担保合同
  /* webpackChunkName: "mangguo-apply-contract" */'@/views_v2/apply-product/components/mangguo-apply-contract/guarantee'
) as any;

// 新银河-杭银 提现协议
const YHApplyConstract = () => import(
  /* webpackChunkName: "apply-newYh-contract" */'@/views_v2/apply-product/components/newYh-contract'
) as any;
const BorrowTableContract = () => import(
  /* webpackChunkName: "borrow-table-contract" */'@/views_v2/apply-product/components/borrow-table-contract'
) as any;
const HSApplyContract = () => import(
  /* webpackChunkName: "hengsheng-apply-contract" */'@/views_v2/apply-product/components/hengsheng-apply-contract'
) as any;
const HSContract = () => import(
  /* webpackChunkName: "hengsheng-contract" */'@/views_v2/apply-product/components/hengsheng-contract'
) as any;
const YhApplyBorrowContract = () => import(
  /* webpackChunkName: "apply-borrow-contract" */'@/views_v2/apply-product/components/apply-borrow-contract'
) as any;

export interface ContractItem {
  /** 文件格式，针对不同的文件格式可做不同处理 */
  fileType?: ContractFileType;
  name: string;
  url?: string;
  clazz?: VueClass<Vue>;
  isThirdUrl?: boolean; // 是否第三方渠道
  // 路由渠道征信，后端在查询到征信协议时获取到并插入到征信协议信息中
  creditRouteChannel?: string,
}

export class ContractInfo {
  items?: ContractItem[] = [];

  /** 第二个资方 */
  spareItems?: ContractItem[];

  /** 第三个资方 */
  thirdItems?: ContractItem[];

  /** 第四个资方 */
  fourthItems?: ContractItem[];

  isThirdUrl?: boolean = false; // 是否请求第三方

  isDynamic?: boolean = false; // 是否动态的 即协议会根据某变量动态变地址
}

export interface ProductContractItem {
  preApplyContracts?: ContractInfo;
  bindContracts?: ContractInfo;
  applyContracts?: ContractInfo;
  pwdContracts?: ContractInfo;
  officalApplyContracts?: ContractInfo;
}

export const ProductContracts: Dictionary<ProductContractItem> = {
  [ZHONGYIN_COMMODITY]: {
    applyContracts: {
      isThirdUrl: true,
      isDynamic: true,
    },
  },
  [XIAOYINGKAYI_COMMODITY]: {
    applyContracts: {
      isThirdUrl: true,
      isDynamic: true,
    },
  },
  [XIAOXIANG_COMMODITY]: {
    applyContracts: {
      isThirdUrl: true,
      isDynamic: true,
    },
  },
  [ZHIDUXIAODAI_COMMODITY]: {
    applyContracts: {
      isThirdUrl: true,
      isDynamic: true,
    },
  },
  [DUXIAOMAN_COMMODITY]: {
    applyContracts: {
      isThirdUrl: true,
      isDynamic: true,
    },
  },
  [NEWORAGE_COMMODITY]: {
    applyContracts: {
      isThirdUrl: true,
      isDynamic: true,
    },
  },
  [ZHONGYOU_COMMODITY]: {
    applyContracts: {
      isThirdUrl: true,
      isDynamic: true,
    },
  },
  [CHONGTIANMEIDAI_COMMODITY]: {
    applyContracts: {
      isThirdUrl: true,
      isDynamic: true,
    },
  },
  [MINSHENG_COMMODITY]: {
    applyContracts: {
      isThirdUrl: true,
      isDynamic: true,
    },
  },
  [ALIPAYMINI_COMMODITY]: {
    preApplyContracts: {
      items: [
        {
          name: '《个人信用报告查询授权书》',
          clazz: YHPreApplyChoose as unknown as VueClass<Vue>,
        },
        {
          name: '《授信额度合同》',
          clazz: YHApplyChoose as unknown as VueClass<Vue>,
        },
      ],
      spareItems: [
        {
          name: '《个人信用报告查询授权书》',
          clazz: HSPreApplyContract as unknown as VueClass<Vue>,
        },
        {
          name: '《个人借款授信额度合同》',
          clazz: HSContract as unknown as VueClass<Vue>,
        },
      ],
    },
    bindContracts: {
      isThirdUrl: true,
    },
    applyContracts: {
      // 临时合同
      items: [
        {
          name: '《个人消费贷款合同》',
          clazz: YHApplyConstract as unknown as VueClass<Vue>,
        },
        {
          name: '《个人信用报告查询授权书》',
          clazz: YHPreApplyChoose as unknown as VueClass<Vue>,
        },
      ],
      spareItems: [
        {
          name: '《个人信用报告查询授权书》',
          clazz: HSPreApplyContract as unknown as VueClass<Vue>,
        },
        {
          name: '《个人消费贷款合同》',
          clazz: HSApplyContract as unknown as VueClass<Vue>,
        },
        {
          name: '《个人借款授信额度合同》',
          clazz: HSContract as unknown as VueClass<Vue>,
        },
      ],
    },
    officalApplyContracts: {
      isThirdUrl: true,
    },
  },
  // 新银河
  // 备注：杭银协议和湖北个人信用报告查询授权书内容相同
  [NEW_YINHE_COMMODITY]: {
    preApplyContracts: {
      items: [
        {
          name: '《个人信用报告查询授权书》',
          clazz: YHPreApplyChoose as unknown as VueClass<Vue>,
        },
        {
          name: '《授信额度合同》',
          clazz: YHApplyChoose as unknown as VueClass<Vue>,
        },
      ],

      spareItems: [
        {
          name: '《个人信用报告查询授权书》',
          clazz: HSPreApplyContract as unknown as VueClass<Vue>,
        },
        {
          name: '《个人借款授信额度合同》',
          clazz: HSContract as unknown as VueClass<Vue>,
        },
      ],
    },
    bindContracts: {
      isThirdUrl: true,
    },
    applyContracts: {
      // 临时合同
      items: [
        {
          name: '《个人消费贷款合同》',
          clazz: YHApplyConstract as unknown as VueClass<Vue>,
        },
        {
          name: '《个人信用报告查询授权书》',
          clazz: YHPreApplyChoose as unknown as VueClass<Vue>,
        },
      ],

      /** 恒生资方 funderCode === 'HENGSHENG' */
      spareItems: [
        {
          name: '《个人信用报告查询授权书》',
          clazz: HSPreApplyContract as unknown as VueClass<Vue>,
        },
        {
          name: '《个人消费贷款合同》',
          clazz: HSApplyContract as unknown as VueClass<Vue>,
        },
        {
          name: '《个人借款授信额度合同》',
          clazz: HSContract as unknown as VueClass<Vue>,
        },
      ],

      /** 芒果小贷资方 funderCode === 'MANGGUOXIAODAI' */
      fourthItems: [
        {
          name: '《贷款告知书》',
          clazz: MGApplyNotice as unknown as VueClass<Vue>,
        },
        {
          name: '《贷款合同》',
          clazz: MGApplyContract as unknown as VueClass<Vue>,
        },
        {
          name: '《委托担保合同》',
          clazz: MGApplyGuarantee as unknown as VueClass<Vue>,
        },
      ],
    },
    officalApplyContracts: {
      isThirdUrl: true,
    },
  },
  // 宜享花 已下线
  [YXH_COMMODITY]: {
    preApplyContracts: {
      items: [
        {
          name: '《电子签名数字证书用户申请确认函》',
          clazz: YXHContractCheckSign as unknown as VueClass<Vue>,
        },
        { name: '《电子签名数字证书用户使用须知》', clazz: YXHSignContract as unknown as VueClass<Vue> },
        { name: '《个人信息授权书》', clazz: YXHContractCheck as unknown as VueClass<Vue> },
        { name: '《个人征信查询授权书》', clazz: YXHContract as unknown as VueClass<Vue> },
      ],
    },
    bindContracts: {
      isThirdUrl: true,
    },
    officalApplyContracts: {
      isThirdUrl: true,
    },
  },
  // 银河 已下线
  [YINHE_COMMODITY]: {
    preApplyContracts: {
      items: [
        {
          name: '个人征信授权书',
          clazz: YhPreApplyContracts as unknown as VueClass<Vue>,
        },
      ],
    },
    applyContracts: {
      items: [
        {
          name: '个人贷款借款合同',
          clazz: YhApplyBorrowContract as unknown as VueClass<Vue>,
        },
      ],
    },
  },
  // 微博
  [WEIBO_COMMODITY]: {
    preApplyContracts: {
      items: [
        {
          name: '个人征信查询授权书',
          url: require('./assets/contracts/weibo/preApplyChoose.txt.html'),
        },
        {
          name: '第三方数据查询授权书',
          url: require('./assets/contracts/weibo/weibochaxun.txt.html'),
        },
        {
          name: '个人征信业务查询授权书',
          url: require('./assets/contracts/weibo/zhengxin.txt.html'),
        },
      ],
    },
    bindContracts: {
      isThirdUrl: true,
    },
  },
  // 胡消
  [HUXIAO_COMMODITY]: {
    preApplyContracts: {
      items: [
        {
          name: '《个人征信等信息查询及使用授权书》',
          url: require('./assets/contracts/Huxiao/preApplyChoose.txt.html'),
        },
        {
          name: '《个人借款额度合同》',
          url: require('./assets/contracts/Huxiao/preApplyBorrow.txt.html'),
        },
      ],
    },
    bindContracts: {
      isThirdUrl: false,
    },
    applyContracts: {
      items: [
        {
          name: '《个人额度借款支用单》',
          url: require('./assets/contracts/Huxiao/applyProduct.txt.html'),
        },
      ],
    },
    officalApplyContracts: {
      isThirdUrl: true,
    },
  },
  // 趣店
  [QUDIAN_COMMODITY]: {
  },
  // 小米
  [XIAOMI_COMMODITY]: {
    // TODO: 小米的要换成在线的
    preApplyContracts: {
      items: [
        {
          name: '《小米贷款用户服务协议》',
          url: 'https://api.jr.mi.com/loan/agreement.html',
          isThirdUrl: true,
        },
        {
          name: '《小米贷款隐私协议》',
          url:
            'https://api.jr.mi.com/loan/setting/agreements/privacy_v1.1.html',
          isThirdUrl: true,
        },
      ],
    },
    bindContracts: {
      items: [
        {
          name: '《捷付睿通股份有限公司支付服务协议》',
          url: require('./assets/contracts/Xiaomi/bind_card.txt.html'),
        },
      ],
    },
    applyContracts: {
      items: [
        {
          name: '《代收业务线上授权协议》',
          url: require('./assets/contracts/Xiaomi/XINWANG_LOAN_V2_a.txt.html'),
        },
        {
          name: '《天星支付扣款授权服务协议》',
          url: require('./assets/contracts/Xiaomi/XINWANG_LOAN_V2_b.txt.html'),
        },
        {
          name: '《中航信托个人消费性借款合同》',
          url: require('./assets/contracts/Xiaomi/XINWANG_LOAN_V2_d.txt.html'),
        },
        {
          name: '《黑河农商担保合同》',
          url: require('./assets/contracts/Xiaomi/BOHAN_XINTUO_PREABS.txt.html'),
        },
        {
          name: '《黑河农商个人消费性借款合同》',
          url: require('./assets/contracts/Xiaomi/YUNNAN_XINTUO.txt.html'),
        },
        {
          name: '《黑河农商综合授权书》',
          url: require('./assets/contracts/Xiaomi/xiaomi_loan_new.txt.html'),
        },
      ],
    },
  },
  // 杭银(测试环境)
  [HANGYINOLD_COMMODITY]: {
    preApplyContracts: {
      items: [
        {
          name: '《中国互联网金融协会信息使用授权书》',
          url: require('./assets/contracts/Hangyin/cduanshouquanshu.txt.html'),
        },
        {
          name: '《个人征信查询授权书》',
          url: require('./assets/contracts/Hangyin/checkPersonInfo.txt.html'),
        },
        {
          name: '《个人信息查询及使用授权书》',
          url: require('./assets/contracts/Hangyin/checkPerson_book.txt.html'),
        },
        {
          name: '《个人借款额度合同》',
          url: require('./assets/contracts/Hangyin/person_borrow.txt.html'),
        },
      ],
    },
    bindContracts: {
      items: [
        {
          name: '《账户委托扣款授权书》',
          url: require('./assets/contracts/Hangyin/card_bind.txt.html'),
        },
      ],
    },
    applyContracts: {
      items: [{ name: '《个人借款电子借据》', clazz: BorrowTableContract as unknown as VueClass<Vue> }],
    },
  },
  // 杭银(正式环境)
  [HANGYIN_COMMODITY]: {
    preApplyContracts: {
      items: [
        {
          name: '《中国互联网金融协会信息使用授权书》',
          url: require('./assets/contracts/Hangyin/cduanshouquanshu.txt.html'),
        },
        {
          name: '《个人征信查询授权书》',
          url: require('./assets/contracts/Hangyin/checkPersonInfo.txt.html'),
        },
        {
          name: '《个人信息查询及使用授权书》',
          url: require('./assets/contracts/Hangyin/checkPerson_book.txt.html'),
        },
        {
          name: '《个人借款额度合同》',
          url: require('./assets/contracts/Hangyin/person_borrow.txt.html'),
        },
      ],
    },
    bindContracts: {
      items: [
        {
          name: '《账户委托扣款授权书》',
          url: require('./assets/contracts/Hangyin/card_bind.txt.html'),
        },
      ],
    },
    applyContracts: {
      items: [{ name: '《个人借款电子借据》', clazz: BorrowTableContract as unknown as VueClass<Vue> }],
    },
  },
};

/**
 * 协议配置
 * @param commodityId
 * @param type
 */
export function getContractsInfo(
  commodityId: string | number,
  type: Partial<ContractEnum>,
): ContractInfo {
  if (commodityId && type) {
    const products = ProductContracts[String(commodityId)] || {};
    const typeName = ContractEnumToContractType[type];

    if (typeName) {
      // 增加默认协议配置，默认为true
      return products[typeName] || { isThirdUrl: true };
    }
  }

  return {};
}

/**
 * 业务背景：部分渠道下的PDF合同，存在特殊字体，在预览模式下，这些特殊字体显示存在兼容性问题，影响用户的查看
  * 所以针对渠道进行合同查看方式的配置：ContractFileType.PDF 为PDF预览查看，ContractFileType.NORMAL 为外跳源链接查看
  * 预览模式链接形如：https://m.hellobike.com/AppFinanceContracts/xxx/index.html?pdf_url=xxx
  * 外跳源链接模式形如：https://hello-finance.oss-cn-hangzhou.aliyuncs.com/xxx/xxx.pdf?xxx=xxx
  * 相关需求：http://wiki.hellobike.com/pages/viewpage.action?pageId=380899706
  * 特殊逻辑：在安卓App环境下，部分渠道的PDF合同 使用外跳源链接的方式打开时，系统会自动跳转至默认浏览器进行下载查看
    * 若外跳使用的是 openThirdPage 方法打开链接，则在用户返回App后会看见一个白屏，需再次点击返回才可以回到原页面
    * 所以为了解决白屏问题，需使用虚拟iframe的方式打开合同链接，这样在用户返回App后可以直接回到原页面
 */
export function openContractWithVirtualIframe(url: string): void {
  const iframeId = 'contractVirtualIframe';
  let iframe = document.getElementById(iframeId) as HTMLIFrameElement;
  if (!iframe) {
    iframe = document.createElement('iframe');
    iframe.id = iframeId;
    document.body.appendChild(iframe);
  }
  iframe.style.display = 'none';
  iframe.src = url;
}

export function openContract(item: ContractItem): void {
  if (item) {
    if (item.clazz) {
      contractPage.openVue(item.clazz);
    } else if (item.url) {
      if (item.isThirdUrl) {
        // 避免多次重复encode
        const needEncode = !/%[0-9a-f]{2}/i.test(item.url);
        const isPdfUrl = !(item.fileType && item.fileType === ContractFileType.NORMAL)
          && (/pdf/g.test(item.url) || item.fileType === ContractFileType.PDF);
        // eslint-disable-next-line no-nested-ternary
        const url = needEncode && !isPdfUrl ? encodeURI(item.url)
          : (isPdfUrl ? `${contractsUrl}?pdf_url=${item.url}` : item.url);

        // 此操作是为了解决：安卓App环境下，外跳至手机浏览器打开合同链接，下载合同文件后返回至App出现白屏的问题
        const useVirtualIframe = URLUtils.needOpenContractWithVirtualIframe(url);
        if (useVirtualIframe) {
          openContractWithVirtualIframe(url);
        } else if (platform.isDingTalk || isH5App) {
          // 针对h5场景，通过弹窗打开
          contractPage.open(url, isPdfUrl);
        } else {
          openThirdPage(url, true, true);
        }
      } else {
        contractPage.open(item.url);
      }
    }
  }
}
